/* eslint-disable jsx-a11y/iframe-has-title */
import { linkResolver } from 'prismic/linkResolver'
import { PrismicLinkWithMeta } from 'prismic/types/link'
import { PrismicVideoEmbed, PrismicVimeoVideoEmbed } from 'prismic/types/video'
import { EducationSlicesVideo, NewsSlicesVideo } from 'prismic-types'

import { Container } from 'components/container/Container'
import { Video } from 'components/video/Video'
import { VideoEmbed } from 'components/video/VideoEmbed'

import { getSource } from 'utils/videoService'

type Props = {
  videoLink?: PrismicLinkWithMeta | null
  videoEmbed?: PrismicVideoEmbed
}

function getWidthHeight(video: PrismicVideoEmbed) {
  const width = parseInt(video?.width.toString() ?? '0', 10)
  const height = parseInt(video?.height.toString() ?? '0', 10)

  return { width, height }
}

export function VideoSlice({ videoLink, videoEmbed }: Props) {
  if (videoLink) {
    return (
      <Container>
        <Video isBackgroundVideo={false} src={linkResolver(videoLink)} />
      </Container>
    )
  }

  if (videoEmbed) {
    const { width, height } = getWidthHeight(videoEmbed)

    const provider = videoEmbed.provider_name ?? null
    const embedUrl = videoEmbed.embed_url ?? null
    const id = parseInt(
      (videoEmbed as PrismicVimeoVideoEmbed).video_id ?? '0',
      10
    )

    if (!provider || !embedUrl) {
      return null
    }

    const src = getSource(provider, id, embedUrl)

    if (!src) {
      return null
    }

    return (
      <VideoEmbed width={width} height={height}>
        <iframe src={src} width={width} height={height} />
      </VideoEmbed>
    )
  }

  // Should never happen
  return null
}

export function prismicSliceToVideo(s: NewsSlicesVideo | EducationSlicesVideo) {
  const link = (s.variation?.primary?.video_link ??
    null) as PrismicLinkWithMeta | null
  const embed = (s.variation?.primary?.video_embed ?? null) as PrismicVideoEmbed

  if (!link && !embed) {
    return null
  }

  return <VideoSlice videoLink={link} videoEmbed={embed} />
}
